import GeneralFilter from '../../../../Model/GeneralFilter'

export default class SystemSettingFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
